/* eslint-disable no-undef */
import { orderBy } from 'lodash';

// #region Used by Home page
const addRecent = async (storeName, payload) => {
  const entity = { ts: Date.now(), id: payload.id, name: payload.name || payload.serial || payload.kymetaProductCode }
  let currentRecents = await $userStore.getItem(storeName);
  if (!currentRecents) currentRecents = [];
  const existingIndex = currentRecents.findIndex(s => s.id == payload.id);
  if (existingIndex == -1) {
    if (currentRecents.length >= 10) {
      currentRecents = orderBy(currentRecents, ['ts'], ['desc']);
      currentRecents.pop();
    }
    currentRecents.unshift(entity);
  } else {
    currentRecents[existingIndex] = entity;
  }
  await $userStore.setItem(storeName, currentRecents);
}
// #endregion

// #region Detail page caches
const setRemote = async (payload) => {
  try { 
    $remoteStore.setItem(payload.id, payload); 
    await addRecent('recentRemotes', payload);
  } catch (ex) { console.error(ex); }
}
const setDevice = async (device) => {
  try { 
    $deviceStore.setItem(device.id, device);
    await addRecent('recentDevices', device); 
  } catch (ex) { console.error(ex); }
}
const setSubscription = async (sub) => {
  try { 
    $subscriptionStore.setItem(sub.id, sub);
    await addRecent('recentSubscriptions', sub); 
  } catch (ex) { console.error(ex); }
}
const setAccounts = async (payload) => {
  try {
    if (payload) {
      payload.forEach(ac => {
        $accountStore.setItem(ac.id, ac);
      })
    }
  } catch (ex) { console.error(ex) }
}
const setSharedAccounts = async (payload) => {
  try {
    if (payload) {
      payload.forEach(sac => {
        $accountStore.setItem(sac.id, sac);
      })
    }
  } catch (ex) { console.error(ex) }
}
// #endregion

// #region Usage caches
const setMonthlyUsage = async (history) => {
  try { 
    if (history.length && history[0].remoteId) {
      $usageMonthlyStore.setItem(history[0].remoteId, history);
    }
  } catch (ex) { console.error(ex); }
}

const setDailyUsage = async (history) => {
  try {
    if (history.length && history[0].remoteId) {
      const key = `${history[0].remoteId}_${history[0].startDate}_${history[0].endDate}`;
      $usageDailyStore.setItem(key, history);
    }
  } catch (ex) { console.error(ex); }
}
// #endregion

const plugin = store => {
  store.subscribe((mutation, state) => {
    // mutation.type is actually the name of the mutation method
    switch (mutation.type) {
      case 'fetchAccounts':
        setAccounts(state.accounts.accounts);
        break;
      case 'addSubscription':
      case 'fetchSubscription':
        setSubscription(state.subscriptions.subscription);
        break;
      case 'addRemote':
      case 'fetchRemote':
      case 'remoteSyncInProgress':
      // case 'updateRemote':
        setRemote(state.remotes.remote);
        break;
      case 'fetchDevice':
      case 'addDevice':
        setDevice(state.devices.device);
        break;
      case 'fetchRemoteHistoricalMetrics':
        setMonthlyUsage(state.remotes.remoteHistoricalMetrics);
        break;
      case 'fetchRemoteUsageDaily':
        setDailyUsage(state.remotes.remoteUsageDaily);
        break;
      case 'fetchSharedAccounts':
        setSharedAccounts(state.accounts.sharedAccounts);
        break;
      default:
        break;
    }
  });
}
export default plugin;
